import { Button } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { Table } from '../../../Table';

export const CustomizeMessageModal = styled.div`
  width: 100%;

  ${Table.S.Wrapper} {
    margin-top: 16px;
    max-width: 100%;
    overflow: auto;
  }
`;

export const Required = styled.span`
  color: var(--color-error-default);
`;

export const RevertButton = styled(Button)`
  gap: 8px;
`;

export const TableName = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const TableNameText = styled.p`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  max-width: 188px;
  overflow: hidden;
`;
